<app-billing-history-search (search)="search($event)" [companies]="companies"></app-billing-history-search>

<div class="billing-history__container">
  <app-billing-history-table-user
    [companies]="companies"
    [tableId]="'organization-bill-list-user'"
    [paymentMethods]="paymentMethods"
    [itemIds]="itemsIds"
    (loadMoreItems)="loadMore()"
  ></app-billing-history-table-user>
</div>
